$(document).ready(function(){
  console.log('ready');
  	//SI on est dans la page produit
	if ( $('body').hasClass('template-product') ) {
      
      //On attend que le formulaire de HulkApp apparaisse
      setTimeout(function(){ 
        //Au click sur Ajout au panier
        $('input.add-to-cart.hulkapps_submit_cart').on('click', function(){
			
          //On attends que HulkApp affiche les erreurs si il y en a
          setTimeout(function(){ 
            $('.hulkapps_option_set > div').each(function(){
              if ($(this).hasClass('validation_error')) {
                var position = $(this).position();
                var offset_top = position.top;
                var header_height = $('section.header-full-width').height();
                var scroll_height = offset_top + header_height;
                
                //On scroll jusqu'à l'erreur
                window.scrollTo(0, scroll_height);
                //On stop la boucle
                return false;
              }
            });
          }, 100);
        }); // FIn action click
        
        //On ajoute le texte
        $('.hulkapps-table.table tbody > tr').each(function() {
          $(this).find('.hulkapps-price').parents('td').append('<span class="hulkapps-text">Buy More and Save</span>');
        });
      }, 5000);
    }
    
  //Recharge la page après suppression d'un produit du panier (pour refresh le total)
  $('.refresh-cart.remove').on('click', function(){
    setTimeout(function(){ 
          location.reload();
    }, 2000);
  });

  //Montre le détail des prix en page produit uniqement lorsque le formulaire ingfinite option de HulkApp s'affiche
  setTimeout(function(){ 
    if ( $('body').hasClass('template-product')) {
      if ( $(".hulkapps_option_title").length == 0) {
      	$("#detail-order").hide();
      }
    }
  }, 8000);
  
 
  //SI on est dans la page panier
  if ( $('body').hasClass('template-cart') ) {
    
    //On check si un item possède les frais de Logo et que le Disounct Volume est actif
	$('.cart-items tbody tr.cart-item').each(function(){ 
      //var discount_volume = $(this).find('.hulkapps-cart-item-price .original_price').length;
      if ( checkIfLogoOrdered($(this)) == true) {
        //SI oui, on cache le prix
        $(this).find('.price-container').addClass('fadeout');	
      }
      
    });
    
    //On attend 3sec avant de déclencher la fontion qui se répétera pendant 10sec
    //10sec dans le cas où la mise à jour des prix de HulkApp tarde à arriver
    setTimeout(function(){ 
      var timesRun = 0;
      var interval = setInterval(function(){
          timesRun += 1;
	      if(timesRun === 1){
             updateHulkPrices();
			 showHulkPrices();
          }

          if(timesRun === 10){
              clearInterval(interval);
          }
      }, 1000);
    }, 3000);
    
    //Fonction de mise à jour des prix si Prix du logo présent
    function showHulkPrices() { 
    	$('.cart-items tbody tr.cart-item').each(function(){
          	//On affiche les prix cachés jusque là
            $(this).find('.price-container').addClass('fadein');
        });
    }
                
    //Fonction de mise à jour des prix si Prix du logo présent
    function updateHulkPrices() { 
          $('.cart-items tbody tr.cart-item').each(function(){
            
            //On vérifie que HulkApp ait mise à jours les prix avant d"intervenir
            if ($(this).find('.hulkapps-cart-item-price .original_price').length > 0 ) {
              
              var $unit_price = $(this).find('.hulkapps-cart-item-price .original_price');
              var $unit_price_discount = $(this).find('.hulkapps-cart-item-price .discounted_price');
              var $total_price = $(this).find('.hulkapps-cart-item-line-price .original_price'); 
              var $total_price_discount = $(this).find('.hulkapps-cart-item-line-price .discounted_price'); 

              var unit_price = parseFloat($unit_price.text().replace('$',''));
              //var unit_price = parseInt($unit_price.attr('doubly-currency-cad'));
              var unit_price_discount = parseFloat($unit_price_discount.text().replace('$',''));
              //var unit_price_discount = parseInt($unit_price_discount.attr('doubly-currency-cad'));
              var total_price = parseFloat($total_price.text().replace('$','').replace(',',''));
              //var total_price = parseInt($total_price.attr('doubly-currency-cad'));
              var total_price_discount = parseFloat($total_price_discount.text().replace('$','').replace(',',''));
              //var total_price_discount = parseInt($total_price_discount.attr('doubly-currency-cad'));
                
              //Si le produit inclus les frais de Logo
              if ( checkIfLogoOrdered($(this)) == true ) {
                //console.log('flou '+$total_price.text());
                $unit_price.text(returnWithoutLogoFee(unit_price));
                $unit_price_discount.text(returnWithoutLogoFee(unit_price_discount));
                $total_price.text(returnWithoutLogoFee(total_price));
                $total_price_discount.text(returnWithoutLogoFee(total_price_discount));

                //On affiche les prix cachés jusque là
                $(this).find('.price-container').addClass('fadein');	

                function returnWithoutLogoFee(price) {
                  var logo_fee = parseInt($('.cart-item-properties.totals > [data-label="setup-fee"]').attr('data-value'));
                  var new_price_float = parseFloat(price);
                  //var new_price_float = parseFloat(price / 100);
                  var new_price_substracted = (new_price_float - logo_fee).toFixed(2);
                  var new_price = new_price_substracted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  var new_price_currency = '$'+new_price+' CAD';
                  //console.log(new_price_float+' and '+new_price_substracted);
                  return new_price_currency;
                }	
              }
            }
          });
    }//Fin de la fonction
    
    //Fonction qui détecte si le Logo est présent dans les détails produit
    function checkIfLogoOrdered($item){
      var has_logo = false;
      $item.find('.product-item-details .cart-item-properties > .cart-item-property').each(function(){
        var label = $(this).find('.cart-item-property-label').text();
        if (label.indexOf('Setup fee') != -1 ) {
          has_logo = true;
        }
      });
      return has_logo;
    }
}
 
});